import React from 'react';
import searchAnimation from '../../../assets/img/button-icons/search-ani.gif';

const SearchingAnimation = () => {
  return (
    <img
      src={searchAnimation}
      //   src="https://via.placeholder.com/150"
      style={{ transform: 'scale(2)' }}
      alt="search"
    />
  );
};

export default SearchingAnimation;
